import React, { Component } from "react";
import { Link } from "react-router-dom";
import Aux from "../../../../hoc/Auxilliary";

class Assignment extends Component {
  render() {
    return (
      <Aux>
        <div className="container-fluid">
          <div className="row">
            <div className="col-xs-12">
              <div className="row knowledge_check_bg01">
                <div className="col-xs-8 col-xs-offset-2">
                  <div className="row">
                    <div className="quiz_box">
                      <h3>Question 1/5:</h3>
                      <h3>Lorem ipsum dolor sit amet, consect etur adipisi cing elit ipsum dolor?</h3>
                      <form>
                        <p>
                          <label className="knowledge_check">
                            Lorem ipsum dolor sit amet, consectetur adipisici
                            <input type="radio" name="radio" />
                            <span className="checkmark" />
                          </label>
                          <label className="knowledge_check">
                            Ipsum dolor sit amet, consectetur adipisicing elit
                            <input type="radio" name="radio" />
                            <span className="checkmark" />
                          </label>
                          <label className="knowledge_check">
                            Sit amet, consectetur adipisicing elit
                            <input type="radio" name="radio" />
                            <span className="checkmark" />
                          </label>
                          <label className="knowledge_check">
                            Borem ipsum dolor sit amet, consectetur adipisic.
                            <input type="radio" name="radio" />
                            <span className="checkmark" />
                          </label>
                        </p>
                        <Link to={`/assignmentresult/${this.props.match.params.id}`}>Submit</Link>
                      </form>
                    </div>
                  </div>
                </div>
                <div className="clearfix" />

                <div className="clearfix" />
              </div>
            </div>
          </div>
        </div>
        <div id="bg">
          <img src="/images/tf_choose_video_image01.jpg" alt="" />
        </div>
      </Aux>
    );
  }
}

export default Assignment;



// WEBPACK FOOTER //
// ./src/containers/User/Learning/Assignment/Assignment.js